// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"144": "4a7004a3","199": "8f51107f","203": "889002af","264": "efc1d37e","282": "4d0f3c2b","31": "600d0a29","354": "76789bd1","466": "4b3f689d","535": "a33ce323","625": "dd7bab45","640": "dc859832","689": "af1fef6c","787": "d3c925a7","878": "b774d1d2",}[chunkId] + ".js"
}